<template>
  <div class="haze main">
    <div
      class="preload"
      :style="[loading ? { display: 'flex' } : { display: 'none' }]"
    >
      <div class="loader"></div>
    </div>
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      data-w-id="b2ac5f58-917a-c8c4-4b27-3b66481451a6"
      role="banner"
      class="nav-bar navbar w-nav"
    >
      <div class="wrapper nav-flex">
        <div class="brand w-nav-brand">
          <img
            v-if="company"
            :src="'/media/logos/' + company.logo"
            alt=""
            class="logo main-logo checkout"
          />
        </div>

        <v-btn v-if="isLoggedIn" color="green darken-1" text @click="logout">
          LOGOUT
        </v-btn>
      </div>
    </div>

    <v-container class="fill-height" v-if="isLoggedIn">
      <router-view />
    </v-container>

    <div class="form-flex-wrapper" v-else>
      <div class="form-header">
        <h2 class="volk">See Your Dental Plan Details</h2>
      </div>
      <div class="section haze full-height">
        <div class="wrapper contact-wrapper" v-if="showLogin">
          <div class="contact-v1">
            <div class="intro">
              <div class="text-label-2">LOGIN</div>
              <!-- <h2 class="volk">Tell Us A Little About Yourself</h2> -->
              <div class="divider-2 animated" />
            </div>

            <div class="full-width w-form contact-form">
              <div id="w-node-8ecf6d038dd7-9ede2a5a">
                <label for="email">Email</label>
                <input
                  v-model="email"
                  id="email"
                  type="email"
                  class="input w-input"
                  maxlength="256"
                  placeholder="johnsmith@foo.com"
                />
              </div>
              <div id="w-node-8ecf6d038ddb-9ede2a5a">
                <label for="password">Password</label>
                <input
                  v-model="password"
                  id="password"
                  type="password"
                  class="input w-input"
                  maxlength="256"
                />
                <a class="forgot-password-link" @click="revealResetForm"
                  >Forgot Password?</a
                >
              </div>
              <a
                id="w-node-f1466e57a656-9ede2a5a"
                class="button login-btn"
                @click="login"
              >
                <div class="text-left bigger">LOG IN</div>
              </a>
            </div>
          </div>
          <div class="left-info">
            <!-- <h2 class="volk">See Your Dental Plan Details</h2> -->
            <div class="cred-actions">
              <p>FIRST TIME HERE?</p>
              <a
                id="w-node-f1466e57a656-9ede2a5a"
                class="button"
                @click="revealResetForm"
              >
                <div class="text-left bigger">CREATE LOGIN</div>
              </a>
            </div>
            <div class="cred-actions">
              <p>NEED A PLAN?</p>
              <a
                id="w-node-f1466e57a656-9ede2a5a"
                class="button"
                href="/signup"
              >
                <div class="text-left bigger">SIGN UP HERE</div>
              </a>
            </div>
          </div>
        </div>
        <div class="wrapper" v-if="showResetForm">
          <div class="contact-v1 full">
            <p v-if="manualReset">
              We've emailed you instructions for resetting your password.
            </p>
            <div v-else>
              <div class="intro">
                <div class="text-label-2">Welcome!</div>
                <div class="divider-2 animated" />
                <p>
                  To see your plan details enter the email address you used when
                  signing up for your dental plan and we will send you a link to
                  set your password.
                </p>
              </div>

              <div class="full-width w-form contact-form">
                <div id="w-node-8ecf6d038dd7-9ede2a5a">
                  <label for="reset-email">Email</label>
                  <input
                    v-model="email"
                    id="reset-email"
                    type="email"
                    class="input w-input"
                    maxlength="256"
                    name="given-name"
                    placeholder="johnsmith@foo.com"
                    autocomplete="given-name"
                  />
                </div>
                <a
                  v-if="!manualReset"
                  id="w-node-f1466e57a656-9ede2a5a"
                  class="button w-inline-block w-clearfix"
                  @click="resetPassword"
                >
                  <div class="text-left bigger">SUBMIT</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div
        data-collapse="medium"
        data-animation="default"
        data-duration="400"
        data-w-id="39566f1c-22aa-ee0a-7be2-f1466e57a64f"
        role="banner"
        class="footer-bar w-nav"
      >
        <div class="wrapper nav-bar-wrapper">
          <div class="footer-columns" v-if="showLogin">
            <a
              id="w-node-f1466e57a656-9ede2a5a"
              class="button bigger w-inline-block w-clearfix"
              @click="login"
            >
              <div class="text-left bigger">SUBMIT</div>
            </a>
            <a
              id="w-node-f1466e57a656-9ede2a5a"
              href="#"
              class="button bigger w-inline-block w-clearfix"
              @click="
                () => {
                  showLogin = false;
                  showResetForm = true;
                }
              "
            >
              <div class="text-left bigger">NEW USER / FORGOT PASSWORD</div>
            </a>
          </div>
          <div class="footer-columns" v-if="showResetForm">
            <a
              v-if="!manualReset"
              id="w-node-f1466e57a656-9ede2a5a"
              class="button bigger w-inline-block w-clearfix"
              @click="resetPassword"
            >
              <div class="text-left bigger">SUBMIT</div>
            </a>
            <a
              id="w-node-f1466e57a656-9ede2a5a"
              href="#"
              class="button bigger w-inline-block w-clearfix"
              @click="
                () => {
                  showLogin = true;
                  showResetForm = false;
                }
              "
            >
              <div class="text-left bigger">GO BACK TO LOGIN</div>
            </a>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import MemberPortalRest from "../rest/MemberPortalRest";
import Rest from "../rest/SignupPortalRest";

export default {
  name: "MemberPortal",
  data() {
    return {
      loading: false,
      loggedIn: false,
      email: "",
      password: "",
      practiceLogo: "/assets/images/nav-logo.png",
      showLogin: false,
      showResetForm: false,
      manualReset: false,
      company: null,
    };
  },
  computed: {
    isLoggedIn() {
      return this.loggedIn;
    },
  },
  created() {
    this.checkSession();
    this.getCompany();
  },
  methods: {
    async getCompany() {
      const { data } = await Rest.FetchCompany();
      this.company = data;
    },
    async checkSession() {
      this.loading = true;
      try {
        const response = await MemberPortalRest.IsSessionActive();

        if (response.data.success) {
          this.loggedIn = true;
          this.practiceLogo = response.data.practice_logo_url;
          this.$router.push({
            name: "member-portal-detail",
          });
        } else {
          this.loggedIn = false;
          this.showLogin = true;
        }
      } catch {
        console.log("Something went wrong");
      } finally {
        this.loading = false;
      }
    },
    async login() {
      this.loading = true;
      try {
        const response = await MemberPortalRest.Login({
          email: this.email,
          password: this.password,
        });

        if (response.data.show_reset_message) {
          console.log(
            "You have to reset your password. Please check your email."
          );
          this.showLogin = false;
        } else {
          this.practiceLogo = response.data.practice_logo_url;
          this.loggedIn = true;
        }
      } catch {
        console.log("Something went wrong.");
      } finally {
        this.loading = false;
        if (this.loggedIn) {
          this.$router.push({
            name: "member-portal-detail",
          });
        }
      }
    },
    async createAccount() {
      this.loading = true;
      try {
        const response = await MemberPortalRest.ResetPassword({
          email: this.email,
        });

        this.showLogin = false;
        this.showResetForm = false;
        this.manualReset = false;
      } catch {
        console.log("Something went wrong.");
      } finally {
        this.loading = false;
      }
    },
    async resetPassword() {
      this.loading = true;
      try {
        const response = await MemberPortalRest.ResetPassword({
          email: this.email,
        });

        this.manualReset = true;
      } catch {
        console.log("Something went wrong.");
      } finally {
        this.loading = false;
      }
    },
    async logout() {
      this.loading = true;
      try {
        const response = await MemberPortalRest.Logout();

        this.loggedIn = false;
        this.showLogin = true;
        this.practiceLogo = "/assets/images/nav-logo.png";
        this.$router.push({
          name: "member-portal",
        });
      } catch {
        console.log("Something went wrong");
      } finally {
        this.loading = false;
      }
    },
    revealResetForm() {
      this.showResetForm = true;
      this.showLogin = false;
    },
  },
};
</script>

<style scoped>
.form-flex-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.form-header {
  padding-top: 3em;
}

.volk {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  text-align: left;
}

.login-btn {
  margin-top: 30px;
}

.left-info {
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex-grow: 1;
}

.cred-actions > p {
  font-size: 14px;
  font-weight: 500;
}

.contact-v1.full {
  width: 100%;
  flex-grow: 1;
}

.forgot-password-link {
  font-family: Roboto, sans-serif;
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 15px;
}

.contact-wrapper {
  display: flex;
  gap: 3em;
  flex-wrap: wrap;
}

h2 {
  margin-top: 0px;
  margin-bottom: 16px;
  font-family: Roboto, sans-serif;
  font-size: 34px;
  line-height: 44px;
  font-weight: 700;
}

.divider-2 {
  width: 88px;
  height: 3px;
  margin-top: 4px;
  margin-bottom: 21px;
  border-radius: 1.5px;
  background-color: #54c0a6;
}

.divider-2.animated {
  background-color: #4b9fe1;
}

.preload {
  display: none;
  position: fixed;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.contact-form {
  display: -ms-grid;
  display: grid;
  width: 100%;
  padding-top: 24px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 24px;
  -ms-grid-columns: 1fr 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
  text-align: left;
}

.text-label-2 {
  display: inline-block;
  margin-bottom: 16px;
  border-radius: 4px;
  font-family: Roboto, sans-serif;
  color: #666;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

.w-input {
  display: block;
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333333;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
}

label {
  display: block;
  margin-bottom: 8px;
  font-family: Roboto, sans-serif;
  color: #2c2c2c;
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

.input {
  height: 48px;
  margin-bottom: 0px;
  padding: 7px 24px 8px;
  border-style: none;
  border-width: 1px;
  border-color: #e3e3e3;
  border-radius: 6px;
  background-color: #f3f3f7;
  -webkit-transition: color 400ms ease, background-color 400ms ease,
    border-color 400ms ease;
  transition: color 400ms ease, background-color 400ms ease,
    border-color 400ms ease;
}

.main {
  height: 100vh;
}

.loader {
  border: 16px solid #e4e4e4;
  border-radius: 50%;
  border-top: 16px solid #4b9fe1;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.display-flex {
  display: flex;
}

.haze {
  background-color: #f3f3f7;
}

.full-height {
  height: 100%;
}

.footer-columns {
  display: flex;
  justify-content: space-between;
}

.button.bigger {
  height: 60px;
  margin-top: 13px;
  margin-right: 5%;
  margin-left: 5%;
  width: 100%;
}

.text-left.bigger {
  font-family: Roboto, sans-serif;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 2px;
}

.button {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 48px;
  padding: 12px 24px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px none transparent;
  border-radius: 6px;
  background-color: #4b9fe1;
  -webkit-transition: background-color 400ms ease, border-color 400ms ease,
    box-shadow 400ms ease, -webkit-transform 400ms ease;
  transition: background-color 400ms ease, border-color 400ms ease,
    box-shadow 400ms ease, -webkit-transform 400ms ease;
  transition: background-color 400ms ease, border-color 400ms ease,
    transform 400ms ease, box-shadow 400ms ease;
  transition: background-color 400ms ease, border-color 400ms ease,
    transform 400ms ease, box-shadow 400ms ease, -webkit-transform 400ms ease;
  font-family: Roboto, sans-serif;
  color: #fff;
  font-size: 17px;
  line-height: 24px;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
}

.section.haze.full-height {
  display: flex;
  width: 100%;
  padding-bottom: 1.5em;
}

.navbar {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: flex-start;
  margin: 0 auto;
}

.nav-bar {
  position: -webkit-sticky;
  position: sticky;
  left: 0px;
  top: 0px;
  right: 0px;
  z-index: 100;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 88px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background-color: #fff;
  align-items: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
}

.logo.main-logo {
  height: 50px;
  max-width: none;
  min-height: 50px;
  min-width: 40px;
}

.nav-bar-wrapper {
  min-width: 800px;
  margin: 0 auto;
}

.nav-flex {
  display: flex;
  flex-direction: row !important;
  justify-content: space-between !important;
}

.intro {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.contact-v1 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 64px 80px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  border-style: solid;
  border-width: 1px;
  border-color: #e3e3e3;
  border-radius: 20px;
  background-color: #fff;
  width: 600px;
}

.wrapper {
  display: flex;
  top: 100px;
  z-index: 2;
  width: 100%;
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 40px;
  padding-left: 40px;
  flex: 0 auto;
  background-color: transparent;
}

.footer-bar {
  position: fixed;
  left: 0%;
  top: auto;
  right: 0%;
  bottom: 0%;
  z-index: 100;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 88px;
  clear: none;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
}

.fill-height {
  margin: 0;
  max-width: 100%;
  padding: 0;
  display: block !important;
}

</style>
